import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiShield, FiLock, FiGlobe } = FiIcons;

const ComplianceBar = ({ className = "" }) => {
  const proofs = [
    { text: "I tråd med arbeidsmiljøloven", icon: FiCheckCircle },
    { text: "Støtter EUs varslingsdirektiv", icon: FiGlobe },
    { text: "GDPR-tilpasset behandling", icon: FiLock },
    { text: "Norskutviklet løsning", icon: FiShield }
  ];

  return (
    <div className={`bg-white border-t border-b border-slate-100 py-10 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-x-12 gap-y-6">
          {proofs.map((proof, i) => (
            <div key={i} className="flex items-center gap-3 text-slate-700 font-bold text-sm md:text-base">
              <div className="bg-green-100 p-1.5 rounded-full text-green-600">
                <SafeIcon icon={proof.icon} className="text-lg" />
              </div>
              <span>{proof.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComplianceBar;